export function isClientRoute(url: string | undefined) {
  if (!url) return false
  const parsedUrl = new URL(url)

  // excludes testing tool foresight which uses internal.cash.app hostname (e.g. /foresight, /foresight/checkout/oauth/callback)
  const isForesight = parsedUrl.pathname.startsWith('/foresight')
  return parsedUrl.hostname === 'internal.cash.app' && !isForesight
}
